// src/redux/reducers/reviewsReducer.js

import {
    FETCH_SETTINGS_REQUEST,
    FETCH_SETTINGS_SUCCESS,
    FETCH_SETTINGS_FAILURE,
    SUBMIT_SETTINGS_REQUEST,
    SUBMIT_SETTINGS_SUCCESS,
    INTEGRATE_THEME_REQUEST,
    INTEGRATE_THEME_SUCCESS,
    CUSTOM_DOMAIN_REQUEST,
    CUSTOM_DOMAIN_SUCCESS,
    CUSTOM_DOMAIN_ERROR,
    GET_CUSTOM_DOMAIN_REQUEST,
    GET_CUSTOM_DOMAIN_SUCCESS,
    SEND_TEST_MAIL_REQUEST,
    SEND_TEST_MAIL_SUCCESS,
    SAVE_MAIL_LOGO_REQUEST,
    SAVE_MAIL_LOGO_SUCCESS,
} from "../actions/settingActions";

const initialState = {
    loading: false,
    settingsArr: [],
    settingsResponse: "",
    customDomain: "",
    error: "",
};

const settingsReducer = (state = initialState, action) => {
    switch (action.type) {
    case FETCH_SETTINGS_REQUEST:
        return { ...state, loading: true };
    case FETCH_SETTINGS_SUCCESS:
        return {
            ...state,
            loading: false,
            settingsArr: action.payload,
            updating: false,
            integrating: false,
            error: "",
        };
    case FETCH_SETTINGS_FAILURE:
        return {
            ...state,
            loading: false,
            settingsArr: [],
            settingsResponse: "",
            error: action.payload,
        };
    case SUBMIT_SETTINGS_REQUEST:
        return {
            ...state,
            ...action.payload,
            loading: false,
            settingsResponse: "",
            updating: true,
        };
    case SUBMIT_SETTINGS_SUCCESS:
        return {
            ...state,
            settingsResponse: action.payload,
            updating: false,
        };
    case INTEGRATE_THEME_REQUEST:
        return { ...state, integrating: true };
    case INTEGRATE_THEME_SUCCESS:
        return { ...state, integrating: false };
    case CUSTOM_DOMAIN_REQUEST:
        return {
            ...state,
            ...action.payload,
            updating: true,
        };
    case CUSTOM_DOMAIN_SUCCESS:
        return {
            ...state,
            settingsResponse: action.payload,
            updating: false,
        };
    case CUSTOM_DOMAIN_ERROR:
        return {
            ...state,
            updating: false,
        };
    case GET_CUSTOM_DOMAIN_REQUEST:
        return {
            ...state,
            ...action.payload,
            loading: true,
        };
    case GET_CUSTOM_DOMAIN_SUCCESS:
        return {
            ...state,
            customDomain: action.payload,
            loading: false,
        };
    case SEND_TEST_MAIL_REQUEST:
        return { ...state };
    case SEND_TEST_MAIL_SUCCESS:
        return { ...state };
    case SAVE_MAIL_LOGO_REQUEST:
        return { ...state };
    case SAVE_MAIL_LOGO_SUCCESS:
        return { ...state };
    default:
        return state;
    }
};

export default settingsReducer;
